import { render, staticRenderFns } from "./CreateMigrationProgressBar.vue?vue&type=template&id=db3b9dc0"
import script from "./CreateMigrationProgressBar.vue?vue&type=script&lang=js"
export * from "./CreateMigrationProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports